import * as StackTrace from 'stacktrace-js';
import {FnBrowserDetail} from '../helpers/fn-browser.detail';


/**
 * Exception Data Model Class used to send Data to server.
 */
export class FNExceptionJson {
  /**
   * variable to uniquely define exception
   */
  id: string;
  /**
   * variable store appId where exception is occur.
   */
  appID = 'HW-Web';
  /**
   * variable store version of app.
   */
  appVer: any;
  /**
   * variable store language
   */
  language = 'Javascript';
  /**
   *  variable store language version
   */
  langVersion: any;
  /**
   * variable store the device where error occur
   * default value is 'web'.;
   */
  deviceType = 'Web';
  /**
   * variable store the device version
   */
  deviceVersion: any = ''; // systemObject.browserMajorVersion;
  /**
   * variable store the device Brand
   */
  deviceBrand = ''; // systemObject.browser;

  /**
   * variable store the device time when exception occur.
   */
  deviceTime: any = new Date();
  /**
   * variable store type of Operating System where error occur
   */
  osType: any = ''; // systemObject.os;
  /**
   * variable store version of Operation System.
   */
  osVersion: any = ''; // systemObject.os+" "+systemObject.osVersion;
  /**
   * variable store the page name in which exception occur.
   */
  page: string;
  /**
   * variable store email ID of cust user.
   */
  custUserEmailID: string;
  /**
   * variable Store Email Id of customer .
   */
  customerEmailID: string;
  /**
   * variable Store Id of Site .
   */
  siteMainID: string;
  /**
   * variable store primarykey of custUser.
   */
  custUserPK: any;
  /**
   * variable store primarykey of Customer.
   */
  customerPk: any;
  /**
   * variable store primarykey of Site.
   */
  sitePk: any;
  /**
   * varible store exception message
   */
  expMessage: string;
  /**
   * variable store the line number where exception occur.
   */
  rootExpLineNum: number;
  /**
   * varible store root stack Trace.
   */
  rootStackTrace: string;
  /**
   * varible store exception stack Trace.
   */
  expStackTrace: any;
  /**
   * Selected object hash of fnexception json
   */
  selectedObjectHash: any = {};
  /**
   * Class name of fnexception json
   */
  className: string; //
  /**
   * Method name of fnexception json
   */
  methodName: string; //
  /**
   * Category name of fnexception json
   */
  categoryName: string; //
  /**
   * Thread name of fnexception json
   */
  threadName: string; //
  /**
   * Last action of fnexception json
   */
  lastAction: string; //
  /**
   * Severity  of fnexception json
   */
  severity: string; //

  /**
   * Creates an instance of fnexception json.
   * and call inits method.
   * @param exception Exception Object to set FNExceptionJson object properties.
   */
  constructor(exception: any) {
    this.init(exception);
  }

  /**
   * sets FNExceptionJson object propeties from Exception Object to send to server.
   * @param exception Exception Object to set FNExceptionJson object properties.
   */
  init(exception: any) {
    const browserDetail = new FnBrowserDetail().browserDetail();
    this.deviceVersion = browserDetail.browserMajorVersion;
    this.deviceBrand = browserDetail.browser;
    this.deviceTime = new Date();
    this.osType = browserDetail.os;
    this.osVersion = this.osType + ' ' + browserDetail.osVersion;
    this.expMessage = exception.message;
    StackTrace.fromError(exception).then((_stackTrace) => {
      const _rootStackTrak = _stackTrace[0];
      this.expStackTrace = _stackTrace.join('\n');
      this.rootStackTrace = _rootStackTrak.toString();
      this.rootExpLineNum = _rootStackTrak.lineNumber;
      this.id = this.expMessage + this.expStackTrace;

    }).catch((_err) => {
      this.expStackTrace = exception.toString();
      this.rootStackTrace = exception.toString();
      this.id = this.expMessage + this.expStackTrace;
    });

  }
}


